import { scenarioAnswerValueTypes, scenarioQuestionTypes } from "helpers/enums";
import { requiredField } from "helpers/validators";

const config = {
    text: {
        // field
        label: "Текст вопроса",
        inputProps: { name: "text" },
        validators: [requiredField],
        required: true,
    },
    nextQuestionId: {
        // select
        label: "Следующий вопрос",
        inputProps: { name: "nextQuestionId" },
        options: [],
        menuPortalTarget: document.body,
    },
    questionType: {
        // select
        label: "Тип вопроса",
        inputProps: { name: "questionType" },
        options: scenarioQuestionTypes,
        menuPortalTarget: document.body,
    },
    answerValueType: {
        // select
        label: "Тип ответа",
        inputProps: { name: "answerValueType" },
        options: scenarioAnswerValueTypes,
        menuPortalTarget: document.body,
    },
    minValueCondition: {
        // field
        label: "Минимальное значение ответа",
        inputProps: { name: "minValueCondition" },
        options: [],
    },
    maxValueCondition: {
        // field
        label: "Максимальное значение ответа",
        inputProps: { name: "maxValueCondition" },
        options: [],
    },
    externalData: {
        value: { propertyName: "" },
        config: {
            propertyName: {
                // field
                label: "PropertyName",
                inputProps: { name: "propertyName" },
            },
        },
    },
    onlyNewPhotos: {
        label: "Запретить загрузку фото из галереи",
        type: "checkbox",
        inputProps: { name: "onlyNewPhotos" },
    },
    id: {},
    scenarioId: {},
};

export { config };
